import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../services/api';

const styles = { /* ... your styles ... */ }; // Add styles for a better look

const MappingPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { spssFileId, unmappedValues } = location.state || {};

    const [masterAds, setMasterAds] = useState([]);
    const [mappings, setMappings] = useState({});
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!spssFileId) {
            navigate('/bcm_norms/file-manager'); // Redirect if no file ID
            return;
        }
        
        const fetchMasterData = async () => {
            try {
                const adsRes = await api.get('/bcm_norms/master-ads/');
                setMasterAds(adsRes.data);
                // Initialize mappings state
                const initialMappings = { AdsName: {} };
                unmappedValues.AdsName.forEach(name => {
                    initialMappings.AdsName[name] = ''; // Default to unmapped
                });
                setMappings(initialMappings);
            } catch (error) {
                console.error("Failed to fetch master data", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMasterData();
    }, [spssFileId, navigate, unmappedValues]);

    const handleMappingChange = (rawName, masterAdId) => {
        setMappings(prev => ({
            ...prev,
            AdsName: { ...prev.AdsName, [rawName]: masterAdId }
        }));
    };

    const handleSubmit = async () => {
        setSubmitting(true);
        try {
            await api.post(`/bcm_norms/spss-files/${spssFileId}/submit-mappings/`, { mappings });
            alert('File processed successfully!');
            navigate('/bcm_norms/file-manager');
        } catch (error) {
            console.error("Failed to submit mappings", error);
            alert(`Error: ${error.response?.data?.error || 'An error occurred.'}`);
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) return <div>Loading mapping data...</div>;

    return (
        <div style={{ padding: '20px' }}>
            <h2>Harmonize Data for File ID: {spssFileId}</h2>
            <p>Map the raw ad names from your file to the master list.</p>

            <table className="table">
                <thead>
                    <tr>
                        <th>Raw Ad Name (from file)</th>
                        <th>Master Ad Name (select or create)</th>
                    </tr>
                </thead>
                <tbody>
                    {unmappedValues.AdsName.map(rawName => (
                        <tr key={rawName}>
                            <td>{rawName}</td>
                            <td>
                                <select
                                    className="form-control"
                                    value={mappings.AdsName[rawName] || ''}
                                    onChange={(e) => handleMappingChange(rawName, e.target.value)}
                                >
                                    <option value="">-- Select Master Ad --</option>
                                    {masterAds.map(ad => (
                                        <option key={ad.id} value={ad.id}>
                                            {ad.name} ({ad.brand_name})
                                        </option>
                                    ))}
                                    {/* In a full version, you'd add a "Create New" option here */}
                                </select>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <button onClick={handleSubmit} disabled={submitting} className="btn btn-primary">
                {submitting ? 'Processing...' : 'Submit and Process Data'}
            </button>
        </div>
    );
};

export default MappingPage; 